'use client'

import { GTM_EVENT } from '@/constants'
import { sendGTMEvent } from '@next/third-parties/google'
import { useEffect } from 'react'

export const SupplierGTMEvent = () => {
  useEffect(() => {
    sendGTMEvent({
      event: GTM_EVENT.SUPPLIER_PROFILE_VIEW,
      'page path': window.location.href,
    })
  }, [])

  return null
}
